import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'feedback',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchFeedbacks: builder.query({
      query: (params) => {
        return ({
          url: '/admin/feedbacks',
          params: {
            ...(params.searchValue && { search: params.searchValue }),
            ...(params.statusFilter && { statusFilter: params.statusFilter }),
            ...(params.partnerFilter && { partnerFilter: params.partnerFilter }),
            ...(params.userFilter && { userFilter: params.userFilter }),
            page: params.page,
          },
        })
      },
      providesTags: (result) => [{ type: 'feedback', id: 'LIST' }],
    }),

    createFeedback: builder.mutation({
      query: (params) => {
        return ({
          url: '/feedbacks',
          method: 'POST',
          body: params,
        })
      },
      invalidatesTags: ['feedback'],
    }),

    updateFeedback: builder.mutation({
      query: ({ feedbackId, params }) => {
        return ({
          url: `/admin/feedbacks/${feedbackId}`,
          method: 'PATCH',
          body: params,
        })
      },
      invalidatesTags: ['feedback'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchFeedbacksQuery,
  useCreateFeedbackMutation,
  useUpdateFeedbackMutation,
} = extendedApi
